import type { HelpFile } from '../../types/help'
import { RolesTestIds } from '../../../testids/RolesTestIds'

export const rolesHelp: HelpFile = {
  docPage: '/docs/access/roles',
  texts: {
    [RolesTestIds.rolesList]:
      'Alle im System definierten Rollen. Eine Rolle bündelt verwandte Zugriffsprofile zu einem zusammengesetzten Recht, das zu einer Funktion oder Persona passt.',
    [RolesTestIds.createRoleButton]:
      'Öffnet den Dialog zum Anlegen einer neuen Rolle inklusive der zu bündelnden Zugriffsprofile.',
    [RolesTestIds.createRoleDialogTitle]:
      'Eine neue Rolle definieren: Name, Beschreibung und die zu bündelnden Zugriffsprofile festlegen.',
    [RolesTestIds.roleKeyInput]:
      'Stabiler Kebab-Case-Schlüssel (z. B. iam-admin), den das OAuth-Claim-Mapping nachschlägt. Nach dem Anlegen schreibgeschützt; etwas wählen, das das IdP-Team unverändert ausspielen kann.',
    [RolesTestIds.roleNameInput]:
      'Kurzer, sprechender Name — erscheint in Auswahllisten und auf Berechtigungen, daher möglichst konkret (z. B. "HR Recruiter" statt "Rolle 7").',
    [RolesTestIds.roleDescriptionInput]:
      'Freitextbeschreibung für Genehmigende und Auditoren — Zweck der Rolle und passende Funktion festhalten.',
    [RolesTestIds.roleKeyError]:
      'Der Schlüssel muss in Kebab-Case (ASCII) sein (z. B. iam-admin), maximal 64 Zeichen. Das OAuth-Claim-Mapping schlägt Rollen anhand dieses Schlüssels nach.',
  },
}
